<template>
  <el-col :span="24" id="change_password" element-loading-text="Fetching page...">
    <el-row type="flex" align="middle" justify="end" class="headerRow">
      <el-col>
        <el-row type="flex" align="middle" justify="start" class="title">Change Password</el-row>
      </el-col>
    </el-row>
    <!-- Start of password section -->
    <el-row align="middle" justify="start">
      <el-row class="padding-20" type="flex" align="middle" justify="start">
        <el-col :span="4"></el-col>
        <el-col :span="12">
          <div class="sub-title">Please create a password meeting the complexity rules below</div>
        </el-col>
      </el-row>
      <el-row class="mb-4" type="flex" align="middle" justify="start">
        <el-col :span="4"></el-col>
        <el-col :span="12">
          <ul class="rules">
            <li>At least 10 characters</li>
            <li>1 upper case character</li>
            <li>1 lower case character</li>
            <li>1 number</li>
            <li>1 special character</li>
            <li>Password cannot contain the users first name or last name</li>
            <li>Password cannot contain the word "password"</li>
          </ul>
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start">
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <el-row type="flex" align="middle" justify="start">Current Password:</el-row>
        </el-col>
        <el-col :span="6">
          <input class="password el-input__inner"
            v-model="currentPassword"
            :name="'current_password' + Math.floor(Math.random() * 1000000 + 1)"
            :autocomplete="'force_off_' + Math.floor(Math.random() * 1000000 + 1)"
            required="required"
          />
        </el-col>
      </el-row>
      <el-row class="p-top-5" type="flex" align="middle" justify="start">
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <el-row type="flex" align="middle" justify="start">New Password:</el-row>
        </el-col>
        <el-col :span="6">
          <input :class="invalidPassword ? 'password el-input__inner error' : 'password el-input__inner'"
            v-model="newPassword"
            :name="'new_password' + Math.floor(Math.random() * 1000000 + 1)"
            :autocomplete="'force_off_' + Math.floor(Math.random() * 1000000 + 1)"
            @change="validatePassword"
            @focus="resetPasswordValidation"
            required="required"
          />
        </el-col>
        <el-col :span="1"></el-col>
        <el-col :span="12" v-if="invalidPassword" class="error">{{ errorMessage }}</el-col>
      </el-row>
      <el-row class="p-top-5" type="flex" align="middle" justify="start">
        <el-col :span="2"></el-col>
        <el-col :span="3">
          <el-row type="flex" align="middle" justify="start">Confirm Password:</el-row>
        </el-col>
        <el-col :span="6">
          <input class="password el-input__inner"
            v-model="confirmPassword"
            :name="'confirm_password' + Math.floor(Math.random() * 1000000 + 1)"
            :autocomplete="'force_off_' + Math.floor(Math.random() * 1000000 + 1)"
            required="required"
          />
        </el-col>
      </el-row>
      <el-row type="flex" align="middle" justify="start" class="p-top-20">
        <el-col :span="5"></el-col>
        <el-col :span="16">
          <el-button type="danger" class="bold" @click="clearPassword">Reset</el-button>
          <template v-if="!isLoading">
            <el-button type="success" class="bold" @click="updatePassword">Change Password</el-button>
          </template>
          <template v-else>
            <el-button type="success" class="bold">Updating...
              <el-icon class="loading-instances is-loading"><Loading/></el-icon></el-button>
          </template>
        </el-col>
      </el-row>
    </el-row>
    <!-- End of password section -->
  </el-col>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      currentPassword: undefined,
      newPassword: undefined,
      confirmPassword: undefined,
      isLoading: false,
      errorMessage: '',
      invalidPassword: false,
      userNames: []
    }
  },

  computed: {
    ...mapGetters({
      getUser: 'getUser',
      activeInstance: 'getActiveInstance'
    })
  },

  methods: {
    clearPassword () {
      this.currentPassword = this.newPassword = this.confirmPassword = undefined
    },

    validatePassword () {
      this.invalidPassword = false
      this.errorMessage = ''

      // Check empty password
      if (!this.newPassword) {
        this.invalidPassword = true
        this.errorMessage = 'Please enter a new password'
        return false
      }

      // Check password length has minimum 10 characters
      if (!(/.{10,}/.test(this.newPassword))) {
        this.invalidPassword = true
        this.errorMessage = 'At least 10 characters'
        return false
      }

      // Check password has 1 upper case character
      if (!(/[A-Z]+/.test(this.newPassword))) {
        this.invalidPassword = true
        this.errorMessage = '1 upper case character required'
        return false
      }

      // Check password has 1 lower case character
      if (!(/[a-z]+/.test(this.newPassword))) {
        this.invalidPassword = true
        this.errorMessage = '1 lower case character required'
        return false
      }

      // Check password has 1 number
      if (!(/[0-9]+/.test(this.newPassword))) {
        this.invalidPassword = true
        this.errorMessage = '1 number required'
        return false
      }

      // Check password has 1 special character
      if (!(/[!@#$%^&*.?]/.test(this.newPassword))) {
        this.invalidPassword = true
        this.errorMessage = '1 special character required'
        return false
      }

      // Check password contain the words of user first name or last name
      if (this.userNames.length) {
        this.userNames.forEach((userName) => {
          if (this.newPassword.match(userName)) {
            this.invalidPassword = true
            this.errorMessage = 'Password cannot contain the users first name or last name'
            return false
          }
        })
      }

      // Check password contains the word "password"
      if (this.newPassword.match('password')) {
        this.invalidPassword = true
        this.errorMessage = 'Password cannot contain the word "password"'
        return false
      }

      return true
    },

    resetPasswordValidation () {
      this.invalidPassword = false
      this.errorMessage = ''
    },

    async updatePassword (event) {
      let hasValidPassword = this.validatePassword()
      if (!this.currentPassword) {
        this.$message({ message: 'Please enter your current password.', type: 'error', duration: 10000 })
        return
      }
      if (!this.newPassword) {
        this.$message({ message: 'Please enter a new password.', type: 'error', duration: 10000 })
        return
      }
      if (!this.confirmPassword) {
        this.$message({ message: 'Please confirm your new password.', type: 'error', duration: 10000 })
        return
      }
      if (this.newPassword !== this.confirmPassword) {
        this.$message({ message: 'The passwords you entered do not match.', type: 'error', duration: 10000 })
        return
      }
      if (this.invalidPassword) {
        this.$message({ message: 'Invalid password.', type: 'error', duration: 2000 })
        return
      }
      if (!hasValidPassword) {
        this.$message({ message: 'Invalid password.', type: 'error', duration: 2000 })
        return
      }
      try {
        this.isLoading = true
        const authValid = await this.checkAuth()
        if (authValid) {
          const response = await this.$store.dispatch('changePassword', {
            old_password: this.currentPassword,
            new_password: this.newPassword,
            new_password_2: this.confirmPassword,
            url: this.activeInstance.url
          })
          if (response && response.status === 200) {
            this.$message({ message: response.body.message, type: 'success', duration: 10000 })
          }
          this.clearPassword()
        }
        this.isLoading = false
      } catch (error) {
        this.isLoading = false
        this.clearPassword()
      }
    },
    // No need to re-up the token
    async checkAuth (request = { username: this.getUser.username, password: this.currentPassword }) {
      try {
        const response = await this.$store.dispatch('reauthenticate', { request, url: this.activeInstance.url })
        if (response && response.status === 201) {
          return true
        } else {
          return false
        }
      } catch (apiError) {
        return false
      }
    },
    log (event) {
      console.log(event)
    }
  },
  mounted () {
    this.$store.dispatch('fetchUserById', this.getUser.userId)
      .then((r) => {
        if (r) {
          if (r.first_name && r.first_name !== '') {
            this.userNames.push(r.first_name)
          }
          if (r.last_name && r.last_name !== '') {
            this.userNames.push(r.last_name)
          }
        }
      })
  }
}
</script>

<style scoped>
  .title { font-size: 1.5em; }
  .headerRow { padding: 15px 20px 0px; }
  .sub-title { font-size: 1.1em; font-weight: 600; }
  a { color: blue; text-decoration: underline; }
  .padding-20 { padding: 20px 20px 20px 20px; }
  .p-top-5 { padding-top: 5px; }
  .p-top-20 { padding-top: 20px; }
  .bold { font-weight: 700; }
  .rules { font-size: 1rem; }
  .error { color: darkred; border-color: darkred; }
  /* element-plus .el-input__inner is borderless (border moved to the wrapper); restore the input box look. */
  .password {
    -webkit-text-security: disc;
    box-sizing: border-box;
    width: 100%;
    height: var(--el-component-size, 32px);
    padding: 1px 11px;
    font-size: var(--el-font-size-base, 14px);
    color: var(--el-input-text-color, var(--el-text-color-regular, #606266));
    background-color: var(--el-fill-color-blank, #fff);
    border: 1px solid var(--el-border-color, #dcdfe6);
    border-radius: var(--el-border-radius-base, 4px);
    outline: none;
  }
  .password:hover { border-color: var(--el-border-color-hover, #c0c4cc); }
  .password:focus { border-color: var(--el-color-primary, #409eff); }
  .password.error { border-color: darkred; }
</style>
